import { memo } from 'react'
import { Badge } from '@components/primitives/Badge.js'
import { MODULOS } from '@utils/constants.js'
import { formatCurrency, formatDate } from '@utils/format.js'
import { STATUS_LABELS, STATUS_VARIANT, type LancamentoItem } from './financeiroTypes.js'

type Props = {
  item: LancamentoItem
  onEdit: () => void
  onDelete: () => void
}

export const LancamentoRow = memo(function LancamentoRow({ item, onEdit, onDelete }: Props) {
  const isReceita = item.tipo === 'receita'
  const metaParts = [
    formatDate(item.data),
    item.categoria,
    item.fornecedor,
    item.moduloId ? MODULOS.find((m) => m.id === item.moduloId)?.titulo : null,
  ].filter(Boolean)

  return (
    <div className='cf3-lancamento' aria-label={`Lançamento: ${item.titulo}`}>
      <div
        className={`cf3-lancamento__icon cf3-lancamento__icon--${isReceita ? 'receita' : 'gasto'}`}
        aria-hidden
      >
        {isReceita ? '↓' : '↑'}
      </div>

      <div className='cf3-lancamento__grid'>
        <div className='cf3-lancamento__row'>
          <span className='cf3-lancamento__titulo'>{item.titulo}</span>
          <span
            className={`cf3-lancamento__valor cf3-lancamento__valor--${isReceita ? 'receita' : 'gasto'}`}
          >
            {isReceita ? '+' : '−'}
            {formatCurrency(item.valor)}
          </span>
        </div>
        <div className='cf3-lancamento__row cf3-lancamento__row--sub'>
          <span className='cf3-lancamento__meta'>{metaParts.join(' · ')}</span>
          <div className='cf3-lancamento__tail'>
            {isReceita ? (
              <Badge label='Receita' variant='success' size='sm' />
            ) : (
              <Badge
                label={STATUS_LABELS[item.status] ?? item.status}
                variant={STATUS_VARIANT[item.status] ?? 'default'}
                size='sm'
              />
            )}
            <div className='cf3-lancamento__actions'>
              <button
                className='cf3-lancamento__btn'
                onClick={onEdit}
                aria-label={`Editar ${item.titulo}`}
                title='Editar'
              >
                Editar
              </button>
              <button
                className='cf3-lancamento__btn cf3-lancamento__btn--danger'
                onClick={onDelete}
                aria-label={`Excluir ${item.titulo}`}
                title='Excluir'
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})
